export default {"src":"/_next/static/media/review.98bfe351.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};